import { useMutation, useQueryClient } from "react-query";

import axios from "axios";

import { projectServiceEndpoint } from "api/project";

import { PROJECT_LAYER_LIST_QUERY_KEYS } from "components/project/layers/queries";
import { PROJECT_SHAPEFILES_QUERY_KEYS } from "components/project/shapefiles/queries";

interface IUseDeleteProjectLinkedMutationParams {
  onError?: (error) => void;
  onMutate?: () => void;
  onSettled?: () => void;
  onSuccess?: (data) => void;
  projectId: string;
}

export async function deleteProjectLinkedShapefile(params) {
  return await axios.delete(
    `${projectServiceEndpoint}/projectShapefile/${params.shapefileId}?projectId=${params.projectId}`
  );
}

/**
 * Linked refers to System or organization shapefiles.
 * @param param0
 * @returns
 */
export function useDeleteProjectLinkedShapefileMutation({
  onError,
  onMutate,
  onSettled,
  onSuccess,
  projectId
}: IUseDeleteProjectLinkedMutationParams) {
  const queryClient = useQueryClient();

  return useMutation(
    (shapefileId: string) => deleteProjectLinkedShapefile({ shapefileId, projectId }),
    {
      onMutate: onMutate && onMutate,
      onSuccess: (data) => {
        queryClient.invalidateQueries({
          queryKey: [PROJECT_SHAPEFILES_QUERY_KEYS.currentProjectShapefiles, projectId]
        });

        queryClient.invalidateQueries({
          queryKey: [PROJECT_LAYER_LIST_QUERY_KEYS.currentProjectLayerList, projectId]
        });

        onSuccess && onSuccess(data);
      },
      onError: (error) => {
        onError && onError(error);
      },
      onSettled: onSettled && onSettled
    }
  );
}
